
// import React, { FC, useEffect, useState } from "react";
// import { CometChat } from "@cometchat/chat-sdk-javascript";
// import "../../styles/AddRaLcModal/AddRaLcModal.css";
// import { CometChatAvatar } from "@cometchat/chat-uikit-react";
// import { ArrowLeft } from "lucide-react";

// interface Props {
//   isOpen: boolean;
//   onClose: () => void;
//   onAdd: (addedUsers: any[]) => void;
//   groupId: string;
// }

// const AddRaLcModal: FC<Props> = ({ isOpen, onClose, onAdd, groupId }) => {
//   const [users, setUsers] = useState<any[]>([]);
//   const [selectedUsers, setSelectedUsers] = useState<any[]>([]);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [addingMembers, setAddingMembers] = useState(false);

//   useEffect(() => {
//     if (isOpen) {
//       fetchUsers();
//       setSelectedUsers([]);
//       setSearch("");
//     }
//   }, [isOpen]);

//   const fetchUsers = async (keyword = "") => {
//     setLoading(true);
//     try {
//       const usersRequest = new CometChat.UsersRequestBuilder()
//         .setLimit(30)
//         .setSearchKeyword(keyword)
//         .build();

//       const userList = await usersRequest.fetchNext();

//       // Filter out users with role "client"
//       const filtered = userList.filter((user: any) => user?.role !== "client");

//       setUsers(filtered);
//     } catch (error) {
//       console.error("Failed to fetch users:", error);
//       setUsers([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const toggleUser = (user: any) => {
//     const exists = selectedUsers.find((u) => u.uid === user.uid);
//     if (exists) {
//       setSelectedUsers(selectedUsers.filter((u) => u.uid !== user.uid));
//     } else {
//       setSelectedUsers([...selectedUsers, user]);
//     }
//   };

//   const addSelectedMembersToGroup = async () => {
//     if (!groupId || selectedUsers.length === 0) return;

//     setAddingMembers(true);

//     try {
//         // Create GroupMember objects
//         const membersList = selectedUsers.map(
//         (user) => new CometChat.GroupMember(user.uid, "participant")
//         );

//         // Add members to group (third argument must be string[])
//         const response = await CometChat.addMembersToGroup(
//         groupId,
//         membersList,
//         ["participant"]
//         );

//         console.log("Added members response:", response);

//         onAdd(selectedUsers);
//         onClose();
//     } catch (error) {
//         console.error("Failed to add members to group:", error);
//         alert("Failed to add members. Please try again.");
//     } finally {
//         setAddingMembers(false);
//     }
//     };

//   if (!isOpen) return null;


//   return (
//     <div className="modal-overlay">
//       <div className="modal-container">
//         {/* Header */}
//         <div className="modal-headers">
//           {/* <span className="back-btn" onClick={onClose}>
//             ←
//           </span> */}
//           <div className="back-btn">
//             <ArrowLeft
//                 size={24}
//                 style={{ cursor: "pointer" }}
//                 onClick={() => onClose()}
//             />
//             </div>
//           <h3>RA or LC</h3>
//         </div>

//         {/* Search */}
//         <div className="search-container">
//           <input
//             type="text"
//             placeholder="Search"
//             value={search}
//             onChange={(e) => {
//               setSearch(e.target.value);
//               fetchUsers(e.target.value);
//             }}
//             disabled={addingMembers}
//           />
//         </div>

//         {/* User List */}
//         <div className="user-list">
//           {loading && <p style={{ padding: "10px" }}>Loading RA or LC...</p>}
//           {!loading && users.length === 0 && (
//             <p style={{ padding: "10px" }}>No RA or LC found.</p>
//           )}
//           {users.map((user) => {
//             const isSelected = !!selectedUsers.find((u) => u.uid === user.uid);
//             const roleLabel =
//                 user.role === "manager"
//                     ? "RA"
//                     : user.role === "lc"
//                         ? "LC"
//                         : "";
//             return (
//               <div
//                 key={user.uid}
//                 className={`user-item ${isSelected ? "selected" : ""}`}
//                 onClick={() => toggleUser(user)}
//               >
//                 <div
//                   className="user-left"
//                   style={{ position: "relative", display: "flex", alignItems: "center" }}
//                 >
//                   <CometChatAvatar image={user.avatar} name={user.name} />
//                   {user.status === "online" && <span className="online-dot" />}
//                   <span className="user-name" style={{ marginLeft: 12 }}>
//                     {user.name}
//                     <div style={{ fontSize: "14px", color: "#888" }}>
//                         {roleLabel}
//                     </div>
//                   </span>
//                 </div>

//                 <div className="custom-checkbox">
//                   {isSelected && <span className="checkmark">✓</span>}
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {/* Footer */}
//         <div className="modal-footer">
//           <button
//             disabled={selectedUsers.length === 0 || addingMembers}
//             onClick={addSelectedMembersToGroup}
//           >
//             {addingMembers ? "Adding..." : "Add Members"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddRaLcModal;

// import React, { FC, useEffect, useState } from "react";
// import { CometChat } from "@cometchat/chat-sdk-javascript";
// import "../../styles/AddRaLcModal/AddRaLcModal.css";
// import { CometChatAvatar } from "@cometchat/chat-uikit-react";
// import { ArrowLeft } from "lucide-react";

// interface Props {
//   isOpen: boolean;
//   onClose: () => void;
//   onAdd: (addedUsers: any[]) => void;
//   groupId: string;
//   loggedInUser: object | null; // <-- allow null
// }

// const AddRaLcModal: FC<Props> = ({ isOpen, onClose, onAdd, groupId, loggedInUser }) => {
//   const [users, setUsers] = useState<any[]>([]);
//   const [selectedUsers, setSelectedUsers] = useState<any[]>([]);
//   console.log("selectedUsers->", selectedUsers);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [addingMembers, setAddingMembers] = useState(false);

//   // Fetch all users excluding clients
//   const fetchUsers = async (keyword = "") => {
//     setLoading(true);
//     try {
//       const usersRequest = new CometChat.UsersRequestBuilder()
//         .setLimit(30)
//         .setSearchKeyword(keyword)
//         .build();

//       const userList = await usersRequest.fetchNext();

//       // Filter out users with role "client"
//       const filtered = userList.filter((user: any) => user?.role !== "client");

//       setUsers(filtered);
//     } catch (error) {
//       console.error("Failed to fetch users:", error);
//       setUsers([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch existing group members to preselect
//   const fetchGroupMembers = async () => {
//     if (!groupId) return;
//     try {
//       const membersRequest = new CometChat.GroupMembersRequestBuilder(groupId)
//         .setLimit(100)
//         .build();

//       const memberList = await membersRequest.fetchNext();

//       // Preselect existing members, exclude users already in selectedUsers AND the logged-in user
//       const preselected = memberList
//         .filter(
//           (member: any) =>
//             !selectedUsers.some(u => u.uid === member.uid) &&
//             member.uid !== (loggedInUser as any).uid // <-- exclude logged-in user
//         )
//         .map((member: any) => ({
//           uid: member.uid,
//           name: member.name,
//           avatar: member.avatar,
//           role: member.scope, // "participant" or "admin"
//           scope: member.scope,
//           isExisting: true
//         }));

//       setSelectedUsers(prev => [...prev, ...preselected]);
//     } catch (error) {
//       console.error("Failed to fetch group members:", error);
//     }
//   };

//   useEffect(() => {
//     if (isOpen) {
//       fetchUsers();
//       fetchGroupMembers();
//       setSearch("");
//     }
//   }, [isOpen]);

//   const toggleUser = (user: any) => {
//     const exists = selectedUsers.find((u) => u.uid === user.uid);

//     if (exists) {
//       if (exists.isExisting) {
//         // If already in group, toggle "marked for removal"
//         setSelectedUsers(prev =>
//           prev.map(u =>
//             u.uid === user.uid ? { ...u, isToRemove: !u.isToRemove } : u
//           )
//         );
//       } else {
//         // Remove newly added user
//         setSelectedUsers(prev => prev.filter(u => u.uid !== user.uid));
//       }
//     } else {
//       // Add new user
//       setSelectedUsers(prev => [...prev, user]);
//     }
//   };

//   const addSelectedMembersToGroup = async () => {
//     if (!groupId || selectedUsers.length === 0) return;

//     setAddingMembers(true);

//     try {
//       // Create GroupMember objects with roles
//       const membersList = selectedUsers.map(
//         (user) =>
//           new CometChat.GroupMember(
//             user.uid,
//             user.role === "manager" || user.role === "admin"
//               ? "admin"
//               : "participant"
//           )
//       );

//       // Add or update members in the group
//       const response = await CometChat.addMembersToGroup(
//         groupId,
//         membersList,
//         ["participant"]
//       );

//       console.log("Updated group members response:", response);

//       onAdd(selectedUsers);
//       onClose();
//     } catch (error) {
//       console.error("Failed to update members:", error);
//       alert("Failed to update members. Please try again.");
//     } finally {
//       setAddingMembers(false);
//     }
//   };

//   const updateGroupMembers = async () => {
//     if (!groupId || selectedUsers.length === 0) return;

//     setAddingMembers(true);

//     try {
//       const newMembers = selectedUsers.filter(u => !u.isExisting);
//       const removeMembers = selectedUsers.filter(u => u.isToRemove);

//       // Add new members
//       if (newMembers.length > 0) {
//         const membersList = newMembers.map(
//           (user) =>
//             new CometChat.GroupMember(
//               user.uid,
//               user.role === "manager" || user.role === "admin"
//                 ? "admin"
//                 : "participant"
//             )
//         );

//         await CometChat.addMembersToGroup(groupId, membersList, ["participant"]);
//         console.log("Added members:", newMembers);
//       }

//       // Remove members
//       if (removeMembers.length > 0) {
//         for (const user of removeMembers) {
//           await CometChat.kickGroupMember(groupId, user.uid); // only 2 args
//           console.log("Removed member:", user.uid);
//         }
//       }

//       onAdd(selectedUsers.filter(u => !removeMembers.includes(u)));
//       onClose();
//     } catch (error) {
//       console.error("Failed to update group members:", error);
//       alert("Failed to update members. Please try again.");
//     } finally {
//       setAddingMembers(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="modal-overlay">
//       <div className="modal-container">
//         {/* Header */}
//         <div className="modal-headers">
//           <div className="back-btn">
//             <ArrowLeft
//               size={24}
//               style={{ cursor: "pointer" }}
//               onClick={onClose}
//             />
//           </div>
//           <h3>RA or LC</h3>
//         </div>

//         {/* Search */}
//         <div className="search-container">
//           <input
//             type="text"
//             placeholder="Search"
//             value={search}
//             onChange={(e) => {
//               setSearch(e.target.value);
//               fetchUsers(e.target.value);
//             }}
//             disabled={addingMembers}
//           />
//         </div>

//         {/* User List */}
//         <div className="user-list">
//           {loading && <p style={{ padding: "10px" }}>Loading RA or LC...</p>}
//           {!loading && users.length === 0 && (
//             <p style={{ padding: "10px" }}>No RA or LC found.</p>
//           )}
//           {users.map((user) => {
//             const isSelected = !!selectedUsers.find((u) => u.uid === user.uid);
//             const roleLabel =
//               user.role === "manager"
//                 ? "RA"
//                 : user.role === "lc"
//                 ? "LC"
//                 : "";
//             return (
//               <div
//                 key={user.uid}
//                 className={`user-item ${isSelected ? "selected" : ""}`}
//                 onClick={() => toggleUser(user)}
//               >
//                 <div
//                   className="user-left"
//                   style={{
//                     position: "relative",
//                     display: "flex",
//                     alignItems: "center",
//                   }}
//                 >
//                   <CometChatAvatar image={user.avatar} name={user.name} />
//                   {user.status === "online" && <span className="online-dot" />}
//                   <span className="user-name" style={{ marginLeft: 12 }}>
//                     {user.name}
//                     <div style={{ fontSize: "14px", color: "#888" }}>
//                       {roleLabel}
//                     </div>
//                   </span>
//                 </div>

//                 <div className="custom-checkbox">
//                   {isSelected && <span className="checkmark">✓</span>}
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {/* Footer */}
//         <div className="modal-footer">
//           <button
//             disabled={selectedUsers.length === 0 || addingMembers}
//             onClick={updateGroupMembers}
//           >
//             {addingMembers
//               ? "Processing..."
//               : selectedUsers.some(u => u.isToRemove)
//                 ? "Remove Members"
//                 : selectedUsers.some(u => !u.isExisting)
//                   ? "Add Members"
//                   : "Update Members"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddRaLcModal;
import React, { FC, useEffect, useState } from "react";
import { CometChat } from "@cometchat/chat-sdk-javascript";
import "../../styles/AddRaLcModal/AddRaLcModal.css";
import { CometChatAvatar } from "@cometchat/chat-uikit-react";
import { ArrowLeft } from "lucide-react";
import axios from "axios";
import { COMETCHAT_CONSTANTS } from "index";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (addedUsers: any[]) => void;
  groupId: string;
  loggedInUser: object | null;
  groupOwnerId: string | null;
}

const AddRaLcModal: FC<Props> = ({ isOpen, onClose, onAdd, groupId, loggedInUser, groupOwnerId }) => {
  const [users, setUsers] = useState<any[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<any[]>([]);
  console.log("selectedUsers->", selectedUsers);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [addingMembers, setAddingMembers] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  console.log("API_BASE_URL->", API_BASE_URL);

  // Fetch all users excluding clients
  // const fetchUsers = async (keyword = "") => {
  //   setLoading(true);
  //   try {
  //     const usersRequest = new CometChat.UsersRequestBuilder()
  //       .setLimit(30)
  //       .setSearchKeyword(keyword)
  //       .build();

  //     const userList = await usersRequest.fetchNext();
  //     const filtered = userList.filter((user: any) => user?.role !== "client");
  //     setUsers(filtered);
  //   } catch (error) {
  //     console.error("Failed to fetch users:", error);
  //     setUsers([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchUsers = async (keyword = "") => {
    setLoading(true);

    try {
      const usersRequest = new CometChat.UsersRequestBuilder()
        .setLimit(30)
        .setSearchKeyword(keyword)
        .build();

      const userList = await usersRequest.fetchNext();

      const filtered = userList.filter(
        (user: any) =>
          user?.role !== "client"
      );

      setUsers(filtered);

    } catch (error) {
      console.error("Failed to fetch users:", error);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch existing group members to preselect
  const fetchGroupMembers = async () => {
    if (!groupId) return;
    try {
      const membersRequest = new CometChat.GroupMembersRequestBuilder(groupId)
        .setLimit(100)
        .build();

      const memberList = await membersRequest.fetchNext();

      const preselected = memberList
        .filter(
          (member: any) =>
            !selectedUsers.some(u => u.uid === member.uid) &&
            member.uid !== (loggedInUser as any).uid
        )
        .map((member: any) => ({
          uid: member.uid,
          name: member.name,
          avatar: member.avatar,
          role: member.scope,
          scope: member.scope,
          isExisting: true,
          isToRemove: false
        }));

      setSelectedUsers(prev => [...prev, ...preselected]);
    } catch (error) {
      console.error("Failed to fetch group members:", error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchUsers();
      fetchGroupMembers();
      setSearch("");
    }
  }, [isOpen]);

  const toggleUser = (user: any) => {
    const exists = selectedUsers.find(u => u.uid === user.uid);

    if (exists) {
      if (exists.isExisting) {
        setSelectedUsers(prev =>
          prev.map(u =>
            u.uid === user.uid ? { ...u, isToRemove: !u.isToRemove } : u
          )
        );
      } else {
        setSelectedUsers(prev => prev.filter(u => u.uid !== user.uid));
      }
    } else {
      setSelectedUsers(prev => [...prev, { ...user, isToRemove: false }]);
    }
  };

  // const updateGroupMembers = async () => {
  //   if (!groupId || selectedUsers.length === 0) return;
  //   setAddingMembers(true);

  //   try {
  //     const newMembers = selectedUsers.filter(u => !u.isExisting);
  //     const removeMembers = selectedUsers.filter(u => u.isToRemove);

  //     // Add new members
  //     if (newMembers.length > 0) {
  //       const membersList = newMembers.map(
  //         user =>
  //           new CometChat.GroupMember(
  //             user.uid,
  //             user.role === "manager" || user.role === "admin" ? "admin" : "participant"
  //           )
  //       );
  //       await CometChat.addMembersToGroup(groupId, membersList, ["participant"]);
  //     }

  //     // Remove members
  //     for (const user of removeMembers) {
  //       await CometChat.kickGroupMember(groupId, user.uid);
  //     }

  //     const finalSelected = selectedUsers.filter(u => !removeMembers.includes(u));
  //     onAdd(finalSelected);
  //     onClose();
  //   } catch (error) {
  //     console.error("Failed to update group members:", error);
  //     alert("Failed to update members. Please try again.");
  //   } finally {
  //     setAddingMembers(false);
  //   }
  // };

  const handleAddMembers = async () => {
    if (!groupId) return;

    const newMembers = selectedUsers.filter(user => !user.isExisting);

    if (newMembers.length === 0) return;

    setAddingMembers(true);

    try {
      const promises = newMembers.map(user => {
        let scope = "participant";

        if (user.role === "manager" || user.role === "admin") {
          scope = "admin";
        } else if (user.role === "lc") {
          scope = "moderator";   // 👈 set moderator here
        }

        const member = new CometChat.GroupMember(user.uid, scope);

        return CometChat.addMembersToGroup(groupId, [member], []);
      });

      await Promise.all(promises);

      const updated = selectedUsers.map(user => ({
        ...user,
        isExisting: true,
        isToRemove: false
      }));

      setSelectedUsers(updated);
      onAdd(updated);

      // Fetch group details first
      let groupName = "";
      try {
        const groupResponse = await CometChat.getGroup(groupId);
        groupName = groupResponse?.getName() || "";
      } catch (err) {
        console.warn("Failed to fetch group details, using groupId instead", err);
      }

      // 🔹 2. Send your custom notification/email
      await Promise.all(
        newMembers.map(async (user) => {
          try {
            const response = await axios.get(
              `${COMETCHAT_CONSTANTS.API_URL}/users/${user.uid}`,
              {
                headers: {
                  apikey: COMETCHAT_CONSTANTS.REST_API_KEY,
                },
              }
            );

            const userData = response.data?.data;
            const email = userData?.metadata?.["@private"]?.email || "";

            const senderName = (loggedInUser as CometChat.User)?.getName() || "Someone";

            const payload = {
              sender_name: senderName,
              receiver_name: groupName,
              receiver_email: email,
              receiver_type: "group",
              type: "text",
              message: `${senderName} added ${userData?.name || user.name}`,
              base_url: `${window.location.origin}/chats/group/${groupId}`,
              sent_at: Math.floor(Date.now() / 1000),
            };

            console.log("Add Members Notification Payload ->", payload);

            try {
              const emailResponse = await axios.post(
                `${API_BASE_URL}/send-chat-email`,
                payload
              );
              console.log("Email API Success ->", emailResponse.data);
            } catch (error: any) {
              console.error("Email API Error ->", error);
              if (error.response) {
                console.error("Status ->", error.response.status);
                console.error("Data ->", error.response.data);
              }
            }
          } catch (err) {
            console.error("Error sending notification:", err);
          }
        })
      );;

    } catch (error) {
      console.error("Failed to add members:", error);
      alert("Failed to add members.");
    } finally {
      setAddingMembers(false);
    }
  };

  const handleRemoveMembers = async () => {
    if (!groupId) return;

    const removeMembers = selectedUsers.filter(
      user => user.isExisting && user.isToRemove
    );

    if (removeMembers.length === 0) return;

    setAddingMembers(true);

    try {
      const promises = removeMembers.map(user =>
        CometChat.kickGroupMember(groupId, user.uid)
      );

      await Promise.all(promises);

      const remaining = selectedUsers.filter(user => !user.isToRemove);

      setSelectedUsers(remaining);
      onAdd(remaining);

      // 🔹 2. Send your custom notification/email
      // Fetch group details first
      let groupName = "";
      try {
        const groupResponse = await CometChat.getGroup(groupId);
        groupName = groupResponse?.getName() || "";
      } catch (err) {
        console.warn("Failed to fetch group details, using groupId instead", err);
      }

      // Then send emails
      await Promise.all(
        removeMembers.map(async (user) => {
          try {
            const response = await axios.get(
              `${COMETCHAT_CONSTANTS.API_URL}/users/${user.uid}`,
              {
                headers: {
                  apikey: COMETCHAT_CONSTANTS.REST_API_KEY,
                },
              }
            );

            const userData = response.data?.data;
            const email = userData?.metadata?.["@private"]?.email || "";

            const senderName = (loggedInUser as CometChat.User)?.getName() || "Someone";

            const payload = {
              sender_name: senderName,
              receiver_name: groupName,
              receiver_email: email,
              receiver_type: "group",
              type: "text",
              message: `${senderName} Removed ${userData?.name || user.name}`,
              base_url: `${window.location.origin}/chats/group/${groupId}`,
              sent_at: Math.floor(Date.now() / 1000),
            };

            console.log("Remove Members Notification Payload ->", payload);

            try {
              const emailResponse = await axios.post(
                `${API_BASE_URL}/send-chat-email`,
                payload
              );
              console.log("Email API Success ->", emailResponse.data);
            } catch (error: any) {
              console.error("Email API Error ->", error);
              if (error.response) {
                console.error("Status ->", error.response.status);
                console.error("Data ->", error.response.data);
              }
            }
          } catch (err) {
            console.error("Error sending notification:", err);
          }
        })
      );

    } catch (error) {
      console.error("Failed to remove members:", error);
      alert("Failed to remove members.");
    } finally {
      setAddingMembers(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        {/* Header */}
        <div className="modal-headers">
          <div className="back-btn">
            <ArrowLeft size={24} style={{ cursor: "pointer" }} onClick={onClose} />
          </div>
          <h3>RA or LC</h3>
        </div>

        {/* Search */}
        <div className="search-container">
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              fetchUsers(e.target.value);
            }}
            disabled={addingMembers}
          />
        </div>

        {/* User List */}
        <div className="user-list">
          {loading && <p style={{ padding: "10px" }}>Loading RA or LC...</p>}
          {!loading && users.length === 0 && <p style={{ padding: "10px" }}>No RA or LC found.</p>}
          {users.map(user => {
            // const isSelected = selectedUsers.some(u => u.uid === user.uid);
            const selectedUser = selectedUsers.find(u => u.uid === user.uid);
            const isSelected = selectedUser && !selectedUser.isToRemove;
            // const roleLabel = user.role === "manager" ? "RA" : user.role === "lc" ? "LC" : "";
            // 🔥 Detect Owner
            const isOwner = user.uid === groupOwnerId;

            // 🔥 Show proper role label
            const roleLabel = isOwner
              ? "RA (Owner)"
              : user.role === "manager"
                ? "RA"
                : user.role === "lc"
                  ? "LC"
                  : "";


            return (
              <div
                key={user.uid}
                // className={`user-item ${isSelected ? "selected" : ""}`}
                // onClick={() => toggleUser(user)}
                className={`user-item 
                  ${isSelected ? "selected" : ""} 
                  ${isOwner ? "owner-disabled" : ""}
                `}
                onClick={() => !isOwner && toggleUser(user)}
              >
                <div className="user-left" style={{ position: "relative", display: "flex", alignItems: "center" }}>
                  <CometChatAvatar image={user.avatar} name={user.name} />
                  {user.status === "online" && <span className="online-dot" />}
                  <span className="user-name" style={{ marginLeft: 12 }}>
                    {user.name}
                    <div style={{ fontSize: "14px", color: "#888" }}>{roleLabel}</div>
                  </span>
                </div>

                <div className="custom-checkbox">{isSelected && <span className="checkmark">✓</span>}</div>
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div className="modal-footer">
          {/* Add Button */}
          <button
            className="add-member"
            disabled={
              addingMembers ||
              !selectedUsers.some(user => !user.isExisting)
            }
            onClick={handleAddMembers}
          >
            {addingMembers ? "Processing..." : "Add Members"}
          </button>

          {/* Remove Button */}
          <button
            className="remove-member"
            disabled={
              addingMembers ||
              !selectedUsers.some(user => user.isExisting && user.isToRemove)
            }
            onClick={handleRemoveMembers}
          >
            {addingMembers ? "Processing..." : "Remove Members"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddRaLcModal;